import { useEffect } from 'react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import type { User } from '@supabase/supabase-js';

const dsn = import.meta.env.VITE_SENTRY_DSN?.trim();

export function initSentry(): void {
  if (!dsn) return;

  Sentry.init({
    dsn,
    enabled: true,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: import.meta.env.PROD ? 1 : 0,
  });
}

export function syncSentryUser(user: User | null): void {
  if (!dsn) return;
  if (user?.id) {
    Sentry.setUser({
      id: user.id,
      email: user.email ?? undefined,
    });
    return;
  }
  Sentry.setUser(null);
}

export { Sentry };
